var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 99.982,
    viewBox: "0 0 100 99.982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#308bcb}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "empty",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4629",
    d: "M32.288 14A11.3 11.3 0 0 0 21 25.288h3.225a8.063 8.063 0 1 1 8.063 8.063h-1.612v9.676H33.9v-6.565A11.289 11.289 0 0 0 32.288 14z",
    className: "cls-1",
    "data-name": "Caminho 4629",
    transform: "translate(12.26 7.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4630",
    d: "M29.838 34a4.838 4.838 0 1 0 4.838 4.838A4.844 4.844 0 0 0 29.838 34zm0 6.45a1.613 1.613 0 1 1 1.613-1.613 1.614 1.614 0 0 1-1.613 1.613z",
    className: "cls-1",
    "data-name": "Caminho 4630",
    transform: "translate(14.71 20.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4631",
    d: "M43.71 4C20.918 4 5 21.9 5 47.541V55.6h6.452v5.854a19.947 19.947 0 0 0 22.155 19.829l3.652-.4v2.14c0 4.648-1.576 14.152-1.59 14.247l-.315 1.879h36.16l-.421-1.953a74.687 74.687 0 0 1-1.576-12.561c0-12.993 3.2-19.582 5.545-24.394a23.477 23.477 0 0 0 2.376-6.246H98.55v-9.68h-3.226V34.64h3.226v-9.676H77.012C74.933 20.612 65.557 4 43.71 4zm28.452 54.827c-2.477 5.093-5.871 12.069-5.871 25.8a68.629 68.629 0 0 0 1.263 11.288H39.147a106.258 106.258 0 0 0 1.337-12.9v-2.5l6.629-.737-.356-3.2-13.505 1.5a16.556 16.556 0 0 1-1.848.1 16.743 16.743 0 0 1-16.726-16.72v-9.079H8.226v-4.838C8.226 23.8 22.818 7.225 43.71 7.225a32.787 32.787 0 0 1 29.72 17.739h-9.174a27.413 27.413 0 1 0 2.021 29.027h7.866a24.7 24.7 0 0 1-1.981 4.836zM82.42 44.315V34.64h3.226v9.676zm-3.226 0h-3.225V34.64h3.226zm-6.452 0h-3.225V34.64h3.226zm-6.452 0h-3.225V34.64h3.226zm-6.451-9.675v9.676h-3.225v9.676h5.94a24.188 24.188 0 1 1-2.431-29.027h-3.51v9.675zm35.485 16.126H59.839v-3.225h35.485zM92.1 44.315h-3.228V34.64H92.1zm3.226-12.9H59.839v-3.226h35.485z",
    className: "cls-1",
    "data-name": "Caminho 4631",
    transform: "translate(2.45 1.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4632",
    d: "M11.838 10.676A4.838 4.838 0 1 0 7 5.838a4.844 4.844 0 0 0 4.838 4.838zm0-6.45a1.613 1.613 0 1 1-1.613 1.613 1.614 1.614 0 0 1 1.613-1.614z",
    className: "cls-1",
    "data-name": "Caminho 4632",
    transform: "translate(3.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4633",
    d: "M51.838 49a4.838 4.838 0 1 0 4.838 4.838A4.844 4.844 0 0 0 51.838 49zm0 6.45a1.613 1.613 0 1 1 1.613-1.613 1.614 1.614 0 0 1-1.613 1.613z",
    className: "cls-1",
    "data-name": "Caminho 4633",
    transform: "translate(28.195 29.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4634",
    d: "M21.838 55a4.838 4.838 0 1 0 4.838 4.838A4.844 4.844 0 0 0 21.838 55zm0 6.45a1.613 1.613 0 1 1 1.613-1.613 1.614 1.614 0 0 1-1.613 1.613z",
    className: "cls-1",
    "data-name": "Caminho 4634",
    transform: "translate(9.807 33.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4635",
    d: "M61.838 18.676A4.838 4.838 0 1 0 57 13.838a4.844 4.844 0 0 0 4.838 4.838zm0-6.45a1.613 1.613 0 1 1-1.613 1.613 1.614 1.614 0 0 1 1.613-1.614z",
    className: "cls-1",
    "data-name": "Caminho 4635",
    transform: "translate(34.324 4.901)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4636",
    d: "M4.225 21.676H7.45V18.45h3.225v-3.225H7.45V12H4.225v3.225H1v3.225h3.225z",
    className: "cls-1",
    "data-name": "Caminho 4636",
    transform: "translate(0 6.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4637",
    d: "M51.225 12.676h3.225V9.45h3.225V6.225H54.45V3h-3.225v3.225H48V9.45h3.225z",
    className: "cls-1",
    "data-name": "Caminho 4637",
    transform: "translate(28.811 1.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4638",
    d: "M63.45 57h-3.225v3.225H57v3.225h3.225v3.225h3.225V63.45h3.225v-3.225H63.45z",
    className: "cls-1",
    "data-name": "Caminho 4638",
    transform: "translate(34.324 34.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4639",
    d: "M55 37h3.225v6.45H55z",
    className: "cls-1",
    "data-name": "Caminho 4639",
    transform: "translate(33.099 22.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4640",
    d: "M51 41h6.45v3.225H51z",
    className: "cls-1",
    "data-name": "Caminho 4640",
    transform: "translate(30.649 24.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4641",
    d: "M57 41h6.45v3.225H57z",
    className: "cls-1",
    "data-name": "Caminho 4641",
    transform: "translate(34.324 24.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4642",
    d: "M55 43h3.225v6.45H55z",
    className: "cls-1",
    "data-name": "Caminho 4642",
    transform: "translate(33.099 25.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4643",
    d: "M5 53h3.225v6.45H5z",
    className: "cls-1",
    "data-name": "Caminho 4643",
    transform: "translate(2.45 31.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4644",
    d: "M1 57h6.45v3.225H1z",
    className: "cls-1",
    "data-name": "Caminho 4644",
    transform: "translate(0 34.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4645",
    d: "M7 57h6.45v3.225H7z",
    className: "cls-1",
    "data-name": "Caminho 4645",
    transform: "translate(3.676 34.307)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4646",
    d: "M5 59h3.225v6.45H5z",
    className: "cls-1",
    "data-name": "Caminho 4646",
    transform: "translate(2.45 35.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4647",
    d: "M4 41h3.225v3.225H4z",
    className: "cls-1",
    "data-name": "Caminho 4647",
    transform: "translate(1.838 24.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4648",
    d: "M57 3h3.225v3.225H57z",
    className: "cls-1",
    "data-name": "Caminho 4648",
    transform: "translate(34.324 1.225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4649",
    d: "M3 7h3.225v3.225H3z",
    className: "cls-1",
    "data-name": "Caminho 4649",
    transform: "translate(1.225 3.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4650",
    d: "M59 49h3.225v3.225H59z",
    className: "cls-1",
    "data-name": "Caminho 4650",
    transform: "translate(35.55 29.406)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.170cafc194e7d842a3d018df8df08a65.svg";
export { ForwardRef as ReactComponent };